<template>
	<transition name="fade" v-if="!loading && showModal && data">
		<div class="collect-modal">
			<div class="collect-modal__card">
				<div class="collect-modal__card__title">
					<h4>Please enter your details</h4>
					<p>We need this data to ensure that the data you are seeing is 100% accurate.</p>
				</div>
				<form @submit.prevent="submit">
					<div class="collect-modal__card__content">
						<!-- Forename -->
						<div class="textfield" :class="{ 'textfield--active': data.forename && data.forename.length }">
							<label class="textfield__label" for="forename">Forename</label>
							<input class="textfield__input" type="text" id="forename" required v-model="data.forename" />
						</div>
						<p v-if="errors.forenameMissing" class="text--error">Please enter your forename</p>
						<!-- Email -->
						<div class="textfield" :class="{ 'textfield--active': data.email && data.email.length }">
							<label class="textfield__label" for="email">Email</label>
							<input class="textfield__input" type="email" id="email" required v-model="data.email" />
						</div>
						<!-- Confirm Email -->
						<div class="textfield" :class="{ 'textfield--active': confirmEmail && confirmEmail.length }">
							<label class="textfield__label" for="confirmEmail">Confirm Email</label>
							<input class="textfield__input" type="email" id="confirmEmail" required v-model="confirmEmail" />
						</div>
						<p v-if="errors.emailMatch" class="text--error">Emails do not match</p>
						<p v-if="errors.emailTaken" class="text--error">Email already in use</p>
						<!-- Mobile Number -->
						<div class="textfield" :class="{ 'textfield--active': data.mobileNumber && data.mobileNumber.length }">
							<input class="textfield__input" type="text" pattern="-?[0-9]*(\.[0-9]+)?" id="mobile" v-model="data.mobileNumber" />
							<label class="textfield__label" for="mobile">Mobile Phone</label>
							<span class="mdl-textfield__error">Mobile must be a number.</span>
						</div>
						<!-- Gender -->
						<div class="mt--2" v-if="!clientIsNavigate">
							<label for="gender">Gender</label>
							<v-select id="gender" :options="genderOptions" v-model="data.gender" :reduce="(item) => item.value" />
						</div>
						<div class="mt--4">
							<label for="dob">Date of birth</label>
							<input type="date" class="textfield__input" v-model="data.dateOfBirth" />
						</div>
					</div>
					<div class="collect-modal__card__actions">
						<button type="submit" class="mdl-button button primary-bg w--100">Submit</button>
					</div>
				</form>
			</div>
		</div>
	</transition>
</template>

<script>
import vSelect from 'vue-select'

export default {
	name: 'collect-modal',
	components: {
		vSelect
	},
	props: {
		user: {
			type: Object,
			required: true,
		},
		clientIsNavigate: {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		loading: true,
		showModal: false,
		data: null,
		confirmEmail: '',
		busy: false,
		errors: {
			emailMatch: false,
			emailTaken: false,
			forenameMissing: false,
		},
		genderOptions: [
			{
				value: 0,
				label: 'Female',
			},
			{
				value: 1,
				label: 'Male',
			},
			{
				value: 2,
				label: 'Prefer not to say',
			},
			{
				value: 3,
				label: 'Other',
			},
		],
	}),
	methods: {
		async submit() {
			if (this.busy) return
			this.busy = true

			if (!this.data.forename && !this.data.forename.length) {
				this.showError('forenameMissing')
				this.busy = false
				return
			}

			if (this.data.email !== this.confirmEmail) {
				this.showError('emailMatch')
				this.busy = false
				return
			}

			let payload = this.data
			payload.tenantId = this.user.fusionAuth_tenant_id
			payload.registeredDt = new Date()

			try {
				var response = await window.axios.patch(`https://abx8y1kjk2.execute-api.eu-west-2.amazonaws.com/production/employee/${this.data.id}`, payload)
			} catch (err) {
				console.log(err)
			}

			if (response.data.errorMessage) {
				this.showError('emailTaken')
				this.busy = false
				return
			}

			try {
				var { data } = await window.axios.get(`https://abx8y1kjk2.execute-api.eu-west-2.amazonaws.com/production/employee`, {
					params: {
						faId: this.user.fusionAuth_user_id,
					},
				})
			} catch (err) {
				console.log(err)
			}

			this.$emit('update', data[0])
			this.showModal = false
			this.busy = false
		},
		showError(type) {
			this.errors[type] = true
			setTimeout(() => {
				this.errors[type] = false
			}, 3000)
		},
	},
	async mounted() {
		// Get User data from DB
		const { data } = await window.axios.get(`https://abx8y1kjk2.execute-api.eu-west-2.amazonaws.com/production/employee`, {
			params: {
				faId: this.user.fusionAuth_user_id,
			},
		})

		this.data = data[0]
		if (this.data.email && this.data.email.length > 5) {
			this.confirmEmail = this.data.email
		}

		if (!this.data.forename || !this.data.email || !this.data.email.length > 5) {
			this.showModal = true
		}

		this.loading = false
	},
}
</script>

<style lang="scss" scoped>

.collect-modal {
	position: fixed;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	background: rgba(34, 34, 34, 0.9);
	overflow: visible;
	overflow-y: scroll;
	z-index: 1001;

	&__card {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		overflow: visible;
		display: flex;
		flex-direction: column;
		font-size: 16px;
		font-weight: 400;
		width: 330px;
		z-index: 1000;
		background: #fff;
		border-radius: 2px;
		box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
    padding: 10px 20px;
    
    @media screen and (max-width: 375px) {
      height: 70%;
      overflow-y: auto;
    }

		&__actions {
			margin: 10px 0;

      button {
        color: #fff;
      }
		}
	}

	.textfield {
		position: relative;
		font-size: 16px;
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
		width: 300px;
		max-width: 100%;
		margin: 0;
		padding-top: 20px;
		padding-bottom: 10px;
	}

	.textfield--active .textfield__label {
		top: 4px;
		font-size: 12px;
	}

	.textfield:focus-within .textfield__label {
		top: 4px;
		font-size: 12px;
	}

	.textfield__input {
		border: none;
		border-bottom: 1px solid rgba(0, 0, 0, 0.12);
		display: block;
		font-size: 16px;
		font-family: 'Helvetica', 'Arial', sans-serif;
		margin: 0;
		padding: 4px;
		width: 100%;
		background: none;
		text-align: left;
		color: inherit;
	}

	.textfield__label {
		bottom: 0;
		color: #888;
		font-size: 16px;
		left: 0;
		right: 0;
		pointer-events: none;
		position: absolute;
		display: block;
		top: 24px;
		width: 100%;
		overflow: hidden;
		white-space: nowrap;
		text-align: left;
		transition: all 0.25s;
	}
}
</style>
